import { useMemo } from 'react';
import { useUserTenantPreference } from 'kineticUtils/hooks';
import { PREFERENCE_KEYS } from 'types/preferenceTypes';

export interface ZoomButtonsPreference {
  showZoomButtons: boolean;
}

export const useMapZoomButtonsState = () => {
  const {
    value: { showZoomButtons = true },
  } = useUserTenantPreference<ZoomButtonsPreference>({
    key: PREFERENCE_KEYS.MAP_ZOOM_BUTTONS,
  });

  const contextValue = useMemo(
    () => ({
      showZoomButtons,
    }),
    [showZoomButtons]
  );

  return contextValue;
};
